import React from "react";
import { defineMessages } from "react-intl";
import { Box } from "@mui/material";
import { dashCharacter } from "../label/EmptyLabel.js";
import "../label/LabelHoc.js";
import { MultiSelect } from "./MultiSelect.js";
import { useFilterSelectClasses } from "./selectStyle.js";
import { SingleSelect } from "./SingleSelect.js";
import { SelectStyle } from "./types.js";
var EmptyPlaceholder = /* @__PURE__ */ ((EmptyPlaceholder2) => {
  EmptyPlaceholder2["Any"] = "any";
  EmptyPlaceholder2["Dash"] = "dash";
  EmptyPlaceholder2["All"] = "all";
  EmptyPlaceholder2["Flag"] = "flag";
  EmptyPlaceholder2["Select"] = "select";
  return EmptyPlaceholder2;
})(EmptyPlaceholder || {});
const localizedEmptyPlaceholders = defineMessages({
  [
    "any"
    /* Any */
  ]: {
    id: "anySelectValue",
    defaultMessage: "Any"
  },
  [
    "all"
    /* All */
  ]: {
    id: "allSelectValue",
    defaultMessage: "All"
  },
  [
    "flag"
    /* Flag */
  ]: {
    id: "flagSelectValue",
    defaultMessage: "Flag"
  },
  [
    "dash"
    /* Dash */
  ]: {
    id: "dashSelectValue",
    defaultMessage: "—"
  },
  [
    "select"
    /* Select */
  ]: {
    id: "selectSelectValue",
    defaultMessage: "Select"
  }
});
const localizedSelect = defineMessages({
  [
    "any"
    /* Any */
  ]: {
    id: "anySelectValue",
    defaultMessage: "Any"
  },
  [
    "all"
    /* All */
  ]: {
    id: "allSelectValue",
    defaultMessage: "All"
  },
  [
    "flag"
    /* Flag */
  ]: {
    id: "flagSelectValue",
    defaultMessage: "Flag"
  },
  selectClearAll: {
    id: "clearAll",
    defaultMessage: "Clear All"
  },
  selectApply: {
    id: "selectApply",
    defaultMessage: "Apply"
  }
});
const Select = React.memo(
  ({
    options,
    value,
    hasRadio,
    multiple,
    selectStyle = SelectStyle.Filter,
    emptyPlaceholder = "any",
    onSubmit,
    enumFormatter,
    label,
    iconLabel,
    disabled,
    chipType,
    ChipComponent,
    isSelectedValueChip,
    showResetButton,
    hasSearch,
    className,
    horizontalPosition = "right",
    startAdornment,
    ...props
  }) => {
    const { classes: classesFilter } = useFilterSelectClasses();
    const selectClassName = selectStyle === SelectStyle.Default || isSelectedValueChip ? className : `${classesFilter.selectFilter} ${className}`;
    const getEmptyValue = () => {
      const localizedEmptyValue = localizedEmptyPlaceholders[emptyPlaceholder];
      return localizedEmptyValue ? localizedEmptyValue : dashCharacter;
    };
    const renderMultiSelect = () => {
      return /* @__PURE__ */ React.createElement(Box, { className: selectClassName }, /* @__PURE__ */ React.createElement(
        MultiSelect,
        {
          disabled,
          options,
          value,
          emptyValue: getEmptyValue(),
          onSubmit,
          enumFormatter,
          label,
          iconLabel,
          chipType,
          ChipComponent,
          showResetButton,
          horizontalPosition,
          hasSearch,
          ...props
        }
      ));
    };
    const renderSingleSelect = () => {
      return /* @__PURE__ */ React.createElement(Box, { className: selectClassName }, /* @__PURE__ */ React.createElement(
        SingleSelect,
        {
          disabled,
          options,
          value,
          emptyValue: getEmptyValue(),
          selectStyle,
          onSubmit,
          hasRadio,
          enumFormatter,
          label,
          chipType,
          ChipComponent,
          isSelectedValueChip,
          showResetButton,
          horizontalPosition,
          startAdornment,
          hasSearch,
          ...props
        }
      ));
    };
    return multiple ? renderMultiSelect() : renderSingleSelect();
  }
);
export {
  EmptyPlaceholder,
  Select,
  localizedEmptyPlaceholders,
  localizedSelect
};
//# sourceMappingURL=Select.js.map
